import { render, staticRenderFns } from "./ChooseUsers.vue?vue&type=template&id=81d5a968&scoped=true"
import script from "./ChooseUsers.vue?vue&type=script&lang=js"
export * from "./ChooseUsers.vue?vue&type=script&lang=js"
import style0 from "./ChooseUsers.vue?vue&type=style&index=0&id=81d5a968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d5a968",
  null
  
)

export default component.exports